import { useNavigate } from 'react-router';
import { PencilIcon } from "../../../../icons"

type Props = {
  type: string
  id: number
}

const EditAction = ({ type, id }: Props) => {
  const navigate = useNavigate();
  const editAction = () => navigate(`/${type}/${id}/edit`);
  return (
    <button
      key={`edit-${type}-${id}`}
      onClick={editAction}
      className="flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 lg:inline-flex lg:w-auto"
    >
      <PencilIcon width={20} height={20}/>
    </button>
  );
}

export default EditAction;
